﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';


import * as Entities_Empty from '../../../../lib/entities/empty';

import tpl_hfSetting from './tpl/hfSetting.html';

export default Marionette.ItemView.extend({
    dialogRegion: '#hfSetting_modal',
    errors: [],
    getTemplate: function () {
        return tpl_hfSetting({ model: this.model.toJSON() });
    },
    initialize: function () {
        this.app = this.options.app;
    },
    ui: {
        'hfSetting_labelName' : '#hfSetting_labelName',
        'hfSetting_inputStatus' : '#hfSetting_inputStatus'
    },
    events: {
        "click #hfSetting_btn01": "onBtn01",
        "click #hfSetting_btn02": "onBtn02"
    },
    onRender: function () {
        var checked = this.model.attributes.Status == 1 ? true : false;
        this.ui.hfSetting_inputStatus.attr('checked', checked);

        //switch(this.model.attributes.Tag) {
        //    case 0 : this.ui.hfSetting_labelName.text(resources.X100969); break;
        //    case 2 : this.ui.hfSetting_labelName.text(resources.X100969); break;
        //}
    },
    onBtn01: function () {
        var self = this;

        var callback = function() {
            self.trigger("dialog:close");
            self.triggerMethod('dialog:btn01clicked', "msg");
        }

        this.validate(callback);
    },
    onBtn02: function () {
        this.triggerMethod('dialog:btn02clicked', "msg");
        this.trigger("dialog:close");
    },
    showErrors: function (errors) {
        _.each(errors, function (error) {
            var controlGroup = this.$('.' + error.name);
            controlGroup.addClass('error');
            controlGroup.find('.help-inline').text(error.message);
        }, this);
    },
    hideErrors: function () {
        this.$('.control-group').removeClass('error');
        this.$('.help-inline').text('');

        this.errors = [];
    },
    validate : function(callback) {
        var self = this;
        this.hideErrors();

        this.ui.hfSetting_inputStatus.is(':checked') ? this.model.attributes.Status = 1 : this.model.attributes.Status = 0;

        if (this.errors.length > 0) {
            this.showErrors(this.errors);
        } else { 
            callback();
        }
    }
});